import { ITSEventDetail } from '../../types';

export const events = {
  /**
   * Subscribe to an event
   */
  on(eventName: string, callback: EventListenerOrEventListenerObject): void {
    window.addEventListener(`its:${eventName}`, callback);
  },

  /**
   * Unsubscribe from an event
   */
  off(eventName: string, callback: EventListenerOrEventListenerObject): void {
    window.removeEventListener(`its:${eventName}`, callback);
  },

  /**
   * Emit an event with a typed payload
   */
  emit<T extends ITSEventDetail>(eventName: string, data: T = {} as T): void {
    const event = new CustomEvent(`its:${eventName}`, {
      detail: data,
      bubbles: true,
    });
    window.dispatchEvent(event);
  },

  /**
   * Listen for an event exactly once
   */
  once(eventName: string, callback: (data: any) => void): void {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent;
      this.off(eventName, handler);
      callback(customEvent.detail);
    };
    this.on(eventName, handler);
  },
};
